<template lang="pug">
  .captcha-image(:class="captchaImageClass")
    template(v-if="!refreshing && imageUrl")
      a(href="#" @click.prevent="onClickImage")
        img(:src="imageUrl" alt="captcha" width="100" height="48")
    template(v-if="refreshing")
      skeleton-box(width="100px" height="48px").skeleton-loader
</template>

<script lang="ts">
import Vue from 'vue';
import {Component, Prop} from 'vue-property-decorator';
import {CaptchaModel} from '@/core/reg/captcha';
import SkeletonBox from '@/components/loaders/SkeletonBox.vue';

class LoginCaptchaModel extends CaptchaModel {
  captchaUrl = '/webapi/auth/logincaptcha';
}

@Component({
  name: 'login-captcha',
  components: {SkeletonBox},
})
export default class LoginCaptcha extends Vue {
  @Prop({default: false})
  disabled!: boolean

  model = new LoginCaptchaModel()

  refreshing = true;

  imageUrl = '';

  get captchaImageClass() {
    return {
      disabled: this.disabled || this.refreshing,
    };
  }

  mounted() {
    this.updatePicture();
  }

  forceUpdate() {
    this.updatePicture();
  }

  onClickImage() {
    if (this.disabled) return;
    this.updatePicture();
  }

  updatePicture() {
    this.$emit('update-start');
    this.refreshing = true;
    this.model.refresh().then(() => {
      this.imageUrl = this.model.imageSource;
      this.refreshing = false;
      this.$emit('update-end');
    }).catch(() => {
      this.refreshing = false;
      this.$emit('update-fail');
    });
  }
}
</script>

<style scoped lang="less">
.captcha-image, .skeleton-loader {
  .border-radius(6px);
  overflow: hidden;
  height: 48px;
}

.captcha-image {
  //border: 1px solid transparent;
}

.captcha-image {
  opacity: 1;
  transition: opacity 0.5s;

  &.disabled {
    opacity: 0.5;
    transition: opacity 0.5s;

    a {
      cursor: not-allowed;
    }
  }
}

.skeleton-loader {
  //border: 1px dashed #999;
}

.border-radius (@radius: 5px) {
  -webkit-border-radius: @radius;
  -moz-border-radius: @radius;
  border-radius: @radius;

  -moz-background-clip: padding;
  -webkit-background-clip: padding-box;
  background-clip: padding-box;
}

.border-radiuses (@topright: 0, @bottomright: 0, @bottomleft: 0, @topleft: 0) {
  -webkit-border-top-right-radius: @topright;
  -webkit-border-bottom-right-radius: @bottomright;
  -webkit-border-bottom-left-radius: @bottomleft;
  -webkit-border-top-left-radius: @topleft;

  -moz-border-radius-topright: @topright;
  -moz-border-radius-bottomright: @bottomright;
  -moz-border-radius-bottomleft: @bottomleft;
  -moz-border-radius-topleft: @topleft;

  border-top-right-radius: @topright;
  border-bottom-right-radius: @bottomright;
  border-bottom-left-radius: @bottomleft;
  border-top-left-radius: @topleft;

  -moz-background-clip: padding;
  -webkit-background-clip: padding-box;
  background-clip: padding-box;
}
</style>
